export const allInfos = [
  { code: 'configsV2', text: 'Configs (V2)' },
  { code: 'allConfigs', text: 'Configs (antigas)' },
  { code: 'wifiConfig', text: 'Wifi Config' },
  { code: 'driverSet', text: 'Motoristas' },
  { code: 'polygonSet', text: 'Polígonos' },
  { code: 'embeddedRulesSet', text: 'Inteligência Embarcada (IE)' },
  { code: 'counters', text: 'Contadores' },
  { code: 'raw', text: 'RAW' },
  { code: 'audioMessage', text: 'AudioMessage' },
  { code: 'audioSet', text: 'AudioSet' },
  { code: 'checklist', text: 'Checklist' },
  { code: 'pointer', text: 'Ponteiro' },
  { code: 'axisUnlock', text: 'Desbloqueio 5a Roda' },
  { code: 'wsReset', text: 'Reset Jornada' },
  { code: 'gpsReset', text: 'Reset GPS' },
  { code: 'dumpRaw', text: 'Dump RAW' },
  { code: 'dumpConfigs', text: 'Dump Configs' },
  { code: 'dumpPointer', text: 'Dump Ponteiro' },
  { code: 'execEi', text: 'Exec IE' }
]

export const samples = [
  {
    label: 'STORE: Motoristas',
    value: 'driverSet',
    sample: {
      drivers: [
        {
          code: '0000005C008446D1',
          tags: ['Master'],
          expirations: [{ date: '2018-01-01T00:00:00-0200' }]
        }
      ],
      cards: [{ code: '5c008446a6', command: 'speed-10' }]
    }
  },
  {
    label: 'STORE: Polígonos',
    value: 'polygonSet',
    sample: [
      {
        value: 200,
        tags: ['Tolerância', 'AreaAviso'],
        points: [
          [-22.85342639926691, -47.046863436698914],
          [-22.854640413011683, -47.047104835510254]
        ]
      }
    ]
  },
  {
    label: 'STORE: Inteligência Embarcada',
    value: 'embeddedRulesSet',
    sample: [
      {
        expressions: [
          { variable: 'polygon', operator: 'eq', value: '24' },
          { variable: 'speed', operator: 'ge', value: '30' }
        ],
        intervalSeconds: 0
      }
    ]
  },
  {
    label: 'STORE: Ponteiro Rawdata Atual',
    value: 'pointer',
    showHexConverter: true,
    sample: { pointer: 10000 }
  },
  {
    label: 'STORE: Configs (antigas)',
    value: 'allConfigs',
    showHexConverter: true,
    sample: {
      rpmConstant: '08',
      speedConstant: '0f4c',
      odometerConstant: '05b3',
      accelerometerThreshold: '62'
    }
  },
  {
    label: 'STORE: Configs (V2)',
    value: 'configsV2',
    sample: {
      allConfigs: [
        {
          key: 'poly-change-warning',
          value: '0x01'
        },
        {
          key: 'pausa-do-gsm-durante-o-dia-em-min',
          value: 1
        }
      ]
    }
  },
  {
    label: 'STORE: Horímetro+Odômetro',
    value: 'counters',
    showHexConverter: true,
    sample: {
      horometer: 108000,
      odometer: 20000
    }
  },
  {
    value: 'audioMessage',
    label: 'STORE: AudioMessage',
    sample: {
      comentario: 'Slot vai de 0-9; todos os campos abaixo em decimal, NAO hex',
      audioMessageId: 123,
      slotNum: 0,
      configByte: 0
    }
  },
  {
    value: 'audioSet',
    label: 'STORE: AudioSet',
    sample: {
      comentario: 'Nao esqueca do configByte de cada slot',
      audioSetId: 123
    }
  },
  {
    value: 'raw',
    label: 'STORE: Raw',
    showHexConverter: true,
    sample: {
      address: 0x0000,
      bytes: '00 01 ff'
    }
  },
  {
    value: 'raw',
    label: 'STORE: AbreJornada',
    sample: {
      address: 0x030003,
      bytes: '20 00 01'
    }
  },
  {
    value: 'raw',
    label: 'STORE: BaixaEstadoRaízen',
    sample: {
      address: 0x030003,
      bytes: '1e 00 00'
    }
  },
  {
    value: 'raw',
    label: 'STORE: FechaJornada',
    sample: {
      address: 0x030003,
      bytes: '20 00 00'
    }
  },
  {
    label: 'EXEC: Reset GPS (0x30001 00)',
    value: 'gpsReset'
  },
  {
    label: 'EXEC: Axis Unlock (0x30005 00)',
    value: 'axisUnlock'
  },
  {
    label: 'EXEC: Reset Jornada (0x30004 01)',
    value: 'wsReset'
  },
  {
    label: 'EXEC: EI',
    value: 'execEi',
    sample: {
      expressions: [
        {
          variable: 'virtual1',
          operator: 'set',
          value: 1
        }
      ]
    }
  },

  {
    label: 'DUMP: Configs',
    value: 'dumpConfigs'
  },
  {
    label: 'DUMP: Pointer',
    value: 'dumpPointer'
  },
  {
    label: 'DUMP: Raw',
    value: 'dumpRaw',
    showHexConverter: true,
    sample: {
      address: 12345,
      length: 10
    }
  },
  {
    label: 'STORE: WifiConfig (template teste do módulo)',
    value: 'wifiConfig',
    sample: {
      '0': {
        ssid: 'Oderon',
        password: 'OderonTelemetria2022'
      },
      '1': {
        ssid: 'meu-ssid',
        password: 'minha-senha'
      },
      '2': {
        ssid: 'meu-ssid',
        password: 'minha-senha'
      },
      '3': {
        ssid: 'meu-ssid',
        password: 'minha-senha'
      },
      '4': {
        ssid: 'meu-ssid',
        password: 'minha-senha'
      }
    }
  },
  {
    label: 'STORE: WifiConfig (template inicial Aripuanã)',
    value: 'wifiConfig',
    sample: {
      '0': {
        ssid: 'NEUSA MULLER',
        password: '756115584'
      },
      '1': {
        ssid: 'TELEMETRIA',
        password: 'arip15935725'
      },
      '2': {
        ssid: 'Oderon',
        password: 'OderonTelemetria2022'
      },
      '3': {
        ssid: 'TIGRAO ADM',
        password: '35651750#'
      },
      '4': {
        ssid: 'nxvoidwserv',
        password: 'Brma#s3rvic3s'
      }
    }
  },
  {
    label: 'STORE: WifiConfig (template inicial Vazante)',
    value: 'wifiConfig',
    sample: {
      '0': {
        ssid: 'ESCRITORIOREPAVE',
        password: 'Repa10.Ve'
      },
      '1': {
        ssid: '..: WN FIBRA :.. Murilo',
        password: 'autoeletrica'
      },
      '2': {
        ssid: 'Eletro_serv_oficina 2',
        password: '@Oficina2022'
      },
      '3': {
        ssid: 'nxvoidwserv',
        password: 'Brma#s3rvic3s'
      },
      '4': {
        ssid: 'nxvoidwmobile',
        password: 'Ari#m0b1l3'
      }
    }
  },
  {
    value: 'setLockControl',
    label: 'Set Lock Control',
    sample: {
      '//1': 'Sempre como string: on=1, off=2, offOnce=3,',
      '//2': 'offUntilDate=4, offUntilDistance=5',
      condition: 'off',
      useSafeguard: true,
      untilDate: '2023-04-20T16:45:00-0300',
      '//3': 'lockUntilM é em metros, não em km',
      untilM: 12000
    }
  },

  {
    value: 'raw',
    label: 'CAN: Seta tempo remanescente',
    sample: {
      address: 196611,
      bytes: '3E 00 10',
      '//': 'este último 10 significa 16 no remainder (1600 seg)'
    }
  },
  {
    value: 'raw',
    label: 'CAN: Habilita modo de sniff',
    sample: {
      address: 196611,
      bytes: '3D 00 02',
      '//': 'este último 02 liga o autobaud'
    }
  },
  {
    value: 'raw',
    label: 'CAN: Desabilita modo de sniff',
    sample: {
      address: 196611,
      bytes: '3D 00 00',
      '//': 'este último 00 faz o firmware voltar ao modo normal'
    }
  }

  // {
  //   value: 'execute-set-gps-debug',
  //   label: 'Execute: Set GPS Debug (0x1602)',
  //   sample: {value: 1}
  // },
  // {
  //   value: 'execute-ei',
  //   label: 'Execute: Embedded Ruleset (0x1603)',
  //   sample: [
  //     {
  //       "expressions":[
  //         {"variable":"polygon","operator":"eq","value":"24"},
  //         {"variable":"speed","operator":"ge","value":"30"}
  //       ],
  //       "intervalSeconds":0
  //     }
  //   ]
  // }
  //   ]
  // }
  // , {
  //   label: 'Raw Command', options: [
  //     {value: 'raw', label: 'Raw', sample: '000102030405...'}
  //   ]
  // }
]
